<template>
  <div>
    <b-navbar toggleable="lg" type="light" variant="light">
      <b-navbar-brand v-if="userProfile">{{userProfile.company_name}}</b-navbar-brand>

    </b-navbar>
  </div>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$store.dispatch("Auth/logout").then(() => {
        this.$router.push({ name: "login" });
      });
    }
  },
  computed: {
    userProfile() {
      return this.$store.state.Auth.userProfile;
    }
  }
};
</script>
<style scoped >
em.light-btn {
  color: black;
}
</style>